import { render, staticRenderFns } from "./base-card-section.vue?vue&type=template&id=192886ba"
import script from "./base-card-section.vue?vue&type=script&setup=true&lang=js"
export * from "./base-card-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-card-section.vue?vue&type=style&index=0&id=192886ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports